import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { HealthScore } from '../components/HealthScore';

export const HealthScoreDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '100%',
        height: '85vh',
        flexDir: 'column',
        px: ['3', '10', '10', '20'],
        py: 5,
        gap: 5,
        overflowY: 'scroll',
        zIndex: '1000',
        pb: '100px',
      }}
    >
      <Box>
        <HealthScore />
      </Box>
    </Box>
  );
};
